export default `
  <xml xmlns="http://www.w3.org/1999/xhtml">
    <block type="Run" deletable="false">
    </block>
  </xml>
`;
